import { Skeleton } from "@/shared/ui";

interface Props {
  variant?: "full" | "cardsOnly";
}

function CardsSkeleton() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
      {Array.from({ length: 8 }).map(function renderCardSkeleton(_, idx) {
        return (
          <div key={idx} className="flex flex-col gap-4 radius-lg surface-component-fill p-5">
            <Skeleton height={24} width={120} />
            <Skeleton height={20} width={160} />
            <div className="flex flex-col border-t border-b surface-base-stroke py-3 gap-3">
              <Skeleton height={16} width={180} />
              <Skeleton height={16} width={150} />
              <Skeleton height={16} width={150} />
            </div>
            <Skeleton height={16} width={120} />
            <div className="flex flex-col gap-2 pt-3 border-t surface-base-stroke">
              <Skeleton height={32} width={"100%"} />
              <Skeleton height={32} width={"100%"} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function ApplicationsPageSkeleton({ variant = "full" }: Props) {
  if (variant === "cardsOnly") {
    return <CardsSkeleton />;
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="radius-3xl surface-base-fill p-7">
        <div className="flex items-center gap-2 mb-7">
          <Skeleton width={192} height={32} className="radius-xs" />
          <Skeleton width={160} height={32} className="radius-xs" />
          <Skeleton width={160} height={32} className="radius-xs" />
          <Skeleton width={160} height={32} className="radius-xs" />
        </div>

        <CardsSkeleton />

        <div className="flex items-center justify-between mt-4">
          <Skeleton width={200} height={20} />
          <div className="flex items-center gap-2">
            <Skeleton width={32} height={32} />
            <Skeleton width={32} height={32} />
            <Skeleton width={32} height={32} />
          </div>
        </div>
      </div>
    </div>
  );
}
